import React from 'react'

import * as modalActions from '../../actions/modal'

import useDispatch from '../../hooks/use-dispatch'

import Button from '../../../../commons/src/components/button'
import Headline from '../../../../commons/src/components/headline'
import Modal from '../../../../commons/src/components/modal'

type Props = {
  title: string
  content: React.ReactNode
  onConfirm: () => void
  confirmButtonLabel?: string
}

const SimpleConfirmModal = ({title, content, onConfirm, confirmButtonLabel = 'Confirm'}: Props) => {
  const dispatch = useDispatch()

  return (
    <Modal
      headline={<Headline label={title} size="l" warning />}
      onClose={() => dispatch(modalActions.close())}
      buttons={
        <>
          <Button hierarchy="ghost" onClick={() => dispatch(modalActions.close())}>
            Cancel
          </Button>
          <Button onClick={onConfirm}>{confirmButtonLabel}</Button>
        </>
      }
    >
      {content}
    </Modal>
  )
}

export default SimpleConfirmModal
